module.exports = __webpack_public_path__ + "public/images/calendar-approved.6192bedaae711aa2f83d271172da822c.svg";